import React from "react";

function CardanoHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Harness the Power of Cardano Blockchain for Your Business
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Unlock the potential of Cardano with Xeer Technology’s
                    customized blockchain development services, optimized for
                    scalability, sustainability, and security.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CardanoHero;
